(function() {
  "use strict";

  function boot() {
    document.querySelectorAll("[data-sticky-atc]:not([data-sticky-atc-ready])").forEach(initStickyAtc)
  }

  function initStickyAtc(root) {
    root.dataset.stickyAtcReady = "true";
    const sectionId = root.dataset.sectionId,
      productForm = document.getElementById(root.dataset.productFormId || `product-form-${sectionId}`),
      picker = document.getElementById(`Product-${sectionId}`)?.querySelector(
        "variant-radios, variant-selects"),
      variantContainer = picker?.closest(".product-variants"),
      variantIdInput = productForm?.querySelector('[name="id"]'),
      quantityInput = productForm?.querySelector('[name="quantity"]'),
      drawer = root.querySelector("[data-sticky-atc-drawer]"),
      drawerPanel = drawer?.querySelector(".sticky-atc-drawer__panel"),
      drawerOptionSlot = drawer?.querySelector("[data-sticky-atc-drawer-options]"),
      drawerFooter = drawer?.querySelector(".sticky-atc-drawer__footer"),
      proxyQuantityContainer = drawer?.querySelector("[data-sticky-atc-proxy-quantity-container]"),
      proxyQuantityInput = drawer?.querySelector("[data-sticky-atc-proxy-quantity]"),
      images = readJson(root.querySelector("[data-sticky-atc-images]"), {}),
      variants = readJson(root.querySelector("[data-sticky-atc-variants]"), []),
      mobileQuery = window.matchMedia("(max-width: 749px)"),
      closeButtons = drawer?.querySelectorAll(".sticky-atc-drawer__close") || [],
      drawerBackdrop = drawer?.querySelector(".sticky-atc-drawer__backdrop"),
      addButtons = root.querySelectorAll("[data-sticky-atc-add]"),
      changeButtons = root.querySelectorAll("[data-sticky-atc-change]"),
      summaryNodes = root.querySelectorAll("[data-sticky-atc-summary]"),
      priceNodes = root.querySelectorAll("[data-sticky-atc-price]"),
      compareNodes = root.querySelectorAll("[data-sticky-atc-compare]"),
      imageNodes = root.querySelectorAll("[data-sticky-atc-image]"),
      pageFooter = document.querySelector("footer.footer") || document.querySelector(
        '[id*="footer"] footer') || document.querySelector('[id*="footer"]');
    let activeVariant = null,
      pickerMarker = null,
      lastOpener = null,
      observer = null,
      footerObserver = null,
      triggerIsPast = !1,
      footerIsNear = !1,
      drawerIsClosing = !1;
      
    const titleNode = document.querySelector(`#Product-${sectionId} .product__title`) || document
      .querySelector(".product__title, h1"),
      hasVariantOptions = !!picker,
      anchorNode = variantContainer || productForm,
      singleVariantTitle = hasVariantOptions ? "" : root.dataset.productTitle?.trim() || titleNode
      ?.textContent?.trim() || "";
    if (!productForm || !variantIdInput || variants.length === 0) {
      root.remove();
      return
    }
    if (!hasVariantOptions) {
      root.classList.add("sticky-atc--single-variant"),
        changeButtons.forEach(button => {
          button.setAttribute("aria-disabled", "true"), button.tabIndex = -1
        })
    }
    pickerMarker = document.createElement("span"), pickerMarker.className = "sticky-atc__sentinel",
      pickerMarker.setAttribute("aria-hidden", "true"), anchorNode.parentNode.insertBefore(
        pickerMarker, anchorNode);
    const fallbackImage = root.querySelector("[data-sticky-atc-image]")?.getAttribute("src") || "",
      currency = root.dataset.currency || "USD",
      moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });

    function readJson(node, fallback) {
      try {
        return node ? JSON.parse(node.textContent) : fallback
      } catch {
        return fallback
      }
    }

    function getVariantById(id) {
      return variants.find(variant => String(variant.id) === String(id)) || null
    }

    function getSourceButtonLabel() {
      return productForm.querySelector('[name="add"] > span')?.textContent?.trim() || root.dataset
        .addLabel || "Add to cart"
    }

    function variantSummary(variant) {
      const title = variant?.title || variant?.options?.filter(Boolean).join(" \xB7 ") || "";
      return title === "Default Title" ? singleVariantTitle : title
    }

    function renderVariant(variant) {
      activeVariant = variant;
      const available = !!variant?.available,
        title = variantSummary(variant),
        imageUrl = images[String(variant?.id)] || fallbackImage,
        label = available ? getSourceButtonLabel() : root.dataset.outOfStockLabel || "Out of stock",
        price = Number(variant?.price || 0),
        compareAtPrice = Number(variant?.compare_at_price || 0),
        hasCompareAtPrice = compareAtPrice > price;
      summaryNodes.forEach(node => {
        node.textContent = title
      }), priceNodes.forEach(node => {
        node.textContent = variant ? moneyFormatter.format(price / 100) : ""
      }), compareNodes.forEach(node => {
        node.hidden = !hasCompareAtPrice, node.textContent = hasCompareAtPrice ? moneyFormatter.format(
          compareAtPrice / 100) : ""
      }), imageNodes.forEach(node => {
        imageUrl && (node.src = imageUrl)
      }), addButtons.forEach(button => {
        button.disabled = !available, button.textContent = label, button.setAttribute("aria-disabled",
          String(!available))
      })
    }

    function syncFromOriginalForm() {
      renderVariant(getVariantById(variantIdInput.value))
    }

    function focusWithoutScrolling(element) {
      if (element?.isConnected) try {
        element.focus({
          preventScroll: !0
        })
      } catch {
        element.focus()
      }
    }

    function getProxyFocusState() {
      const focused = document.activeElement;
      return focused?.matches?.("[data-sticky-atc-proxy-option-index]") ? {
        optionIndex: focused.dataset.stickyAtcProxyOptionIndex,
        value: focused.value
      } : null
    }

    function restoreProxyFocus(focusState) {
      if (!focusState || !drawerOptionSlot) return;
      const nextControl = Array.from(drawerOptionSlot.querySelectorAll(
        "[data-sticky-atc-proxy-option-index]")).find(control => control.dataset
        .stickyAtcProxyOptionIndex === focusState.optionIndex && control.value === focusState.value);
      nextControl && !nextControl.disabled && focusWithoutScrolling(nextControl)
    }

    function proxyVariantClassName() {
      const classes = Array.from(variantContainer.classList).filter(className => className !==
        "variants-hidden" && className !== "variants-visible");
      return classes.includes("product-variants") || classes.push("product-variants"), classes.push(
        "sticky-atc-proxy-variants"), classes.join(" ")
    }

    function relinkProxyControl(control, labels, optionIndex, valueIndex) {
      const originalId = control.id,
        proxyId = `sticky-atc-proxy-${sectionId}-${optionIndex}-${valueIndex}`;
      control.id = proxyId, control.name = `sticky-atc-proxy-${sectionId}-${optionIndex}`, control
        .removeAttribute("form"), control.dataset.stickyAtcProxyOptionIndex = String(optionIndex), control
        .dataset.stickyAtcProxyValue = control.value, labels.forEach(label => {
          label.htmlFor === originalId && (label.htmlFor = proxyId)
        })
    }

    function buildRadioProxy(proxyPicker) {
      picker.querySelectorAll("fieldset.product-form-input").forEach((sourceFieldset, optionIndex) => {
        const proxyFieldset = sourceFieldset.cloneNode(!0);
        proxyFieldset.dataset.stickyAtcProxyOptionGroup = String(optionIndex);
        const labels = Array.from(proxyFieldset.querySelectorAll("label"));
        proxyFieldset.querySelectorAll('input[type="radio"]').forEach((control, valueIndex) => {
          relinkProxyControl(control, labels, optionIndex, valueIndex)
        }), proxyPicker.appendChild(proxyFieldset)
      })
    }

    function buildSelectProxy(proxyPicker) {
      picker.querySelectorAll(".product-form-input-dropdown").forEach((sourceGroup, optionIndex) => {
        const proxyGroup = sourceGroup.cloneNode(!0),
          proxySelect = proxyGroup.querySelector("select");
        proxySelect && (relinkProxyControl(proxySelect, Array.from(proxyGroup.querySelectorAll(
          "label")), optionIndex, 0), proxyGroup.dataset.stickyAtcProxyOptionGroup = String(
          optionIndex), proxyPicker.appendChild(proxyGroup))
      })
    }

    function syncProxyPicker() {
      if (!drawerOptionSlot) return;
      if (!hasVariantOptions) {
        drawerOptionSlot.replaceChildren(), drawerOptionSlot.classList.add("is-empty");
        return
      }
      drawerOptionSlot.classList.remove("is-empty");
      const focusState = getProxyFocusState(),
        proxyPicker = document.createElement("div");
      proxyPicker.className = proxyVariantClassName(), proxyPicker.setAttribute(
          "data-sticky-atc-proxy-picker", ""), picker.tagName === "VARIANT-RADIOS" ? buildRadioProxy(
          proxyPicker) : buildSelectProxy(proxyPicker), drawerOptionSlot.replaceChildren(proxyPicker),
        restoreProxyFocus(focusState)
    }

    function getOriginalControl(optionIndex, value) {
      if (picker.tagName === "VARIANT-RADIOS") {
        const fieldset = picker.querySelectorAll("fieldset.product-form-input")[optionIndex];
        return Array.from(fieldset?.querySelectorAll('input[type="radio"]') || []).find(control => control
          .value === value)
      }
      return picker.querySelectorAll("select")[optionIndex] || null
    }

    function forwardProxyVariantChange(event) {
      const proxyControl = event.target.closest?.("[data-sticky-atc-proxy-option-index]");
      if (!proxyControl || proxyControl.disabled) return;
      const optionIndex = Number(proxyControl.dataset.stickyAtcProxyOptionIndex),
        originalControl = getOriginalControl(optionIndex, proxyControl.value);
      if (!originalControl || originalControl.disabled) {
        syncProxyPicker();
        return
      }
      originalControl.type === "radio" ? originalControl.checked || originalControl.click() :
        originalControl.value !== proxyControl.value && (originalControl.value = proxyControl.value,
          originalControl.dispatchEvent(new Event("change", {
            bubbles: !0
          })))
    }

    function syncProxyQuantity() {
      !proxyQuantityInput || !quantityInput || (["min", "max", "step"].forEach(attribute => {
        quantityInput.hasAttribute(attribute) ? proxyQuantityInput.setAttribute(attribute,
          quantityInput.getAttribute(attribute)) : proxyQuantityInput.removeAttribute(attribute)
      }), proxyQuantityInput.value = quantityInput.value || proxyQuantityInput.min || "1")
    }

    function forwardProxyQuantityChange() {
      if (!proxyQuantityInput || !quantityInput) return;
      const min = Number(proxyQuantityInput.min) || 1,
        max = proxyQuantityInput.max === "" ? 1 / 0 : Number(proxyQuantityInput.max),
        requestedValue = Number(proxyQuantityInput.value) || min,
        nextValue = Math.min(Math.max(requestedValue, min), Number.isFinite(max) ? max : 1 / 0);
      proxyQuantityInput.value = String(nextValue), String(quantityInput.value) !== String(nextValue) && (
        quantityInput.value = String(nextValue), quantityInput.dispatchEvent(new Event("input", {
          bubbles: !0
        })), quantityInput.dispatchEvent(new Event("change", {
          bubbles: !0
        })))
    }

    function closeDrawer({
      restoreFocus = !0,
      afterClose = null
    } = {}) {
      !drawer || drawer.hidden || drawerIsClosing || (drawerIsClosing = !0, drawer.classList.remove(
        "is-open"), drawer.setAttribute("aria-hidden", "true"), window.setTimeout(() => {
        drawer.contains(document.activeElement) && document.activeElement.blur(), drawer.hidden = !0,
          document.body.classList.remove("sticky-atc-drawer-open"), typeof removeTrapFocus ==
          "function" && removeTrapFocus(), restoreFocus && focusWithoutScrolling(lastOpener),
          drawerIsClosing = !1, typeof afterClose == "function" && requestAnimationFrame(afterClose)
      }, 240))
    }

    function openDrawer(opener) {
      if (!hasVariantOptions || !mobileQuery.matches || !drawer || !drawerOptionSlot) {
        scrollToOptions();
        return
      }
      lastOpener = opener || document.activeElement, syncProxyPicker(), syncProxyQuantity(),
        proxyQuantityContainer?.toggleAttribute("hidden", !quantityInput), drawerFooter?.classList.toggle(
          "sticky-atc-drawer__footer--button-only", !quantityInput), drawer.hidden = !1, drawerIsClosing = !
        1, drawer.setAttribute("aria-hidden", "false"), document.body.classList.add(
          "sticky-atc-drawer-open"), requestAnimationFrame(() => drawer.classList.add("is-open")), window
        .setTimeout(() => {
          typeof trapFocus == "function" ? trapFocus(drawer, drawerPanel) : drawerPanel?.focus()
        }, 250)
    }

    function scrollToOptions() {
      const scrollTarget = variantContainer || anchorNode;
      if (!scrollTarget) return;
      const offset = (document.querySelector(".header, sticky-header")?.getBoundingClientRect().height ||
          0) + 18,
        top = scrollTarget.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth"
      })
    }

    function changeOptions(event) {
      if (!hasVariantOptions) return;
      mobileQuery.matches ? openDrawer(event?.currentTarget) : scrollToOptions()
    }

    function submitOriginalForm() {
      typeof productForm.requestSubmit == "function" ? productForm.requestSubmit() : productForm
        .querySelector('[name="add"]')?.click()
    }

    function addViaOriginalForm() {
      activeVariant?.available && (drawer?.hidden ? submitOriginalForm() : closeDrawer({
        restoreFocus: !1,
        afterClose: submitOriginalForm
      }))
    }

    function triggerOffset() {
      return mobileQuery.matches ? 140 : 160
    }

    function footerHideOffset() {
      return mobileQuery.matches ? 112 : 120
    }

    function syncVisibility() {
      const cartIsOpen = document.body.classList.contains("header-mini-cart-open"),
        shouldShow = triggerIsPast && !footerIsNear && !cartIsOpen;
      root.classList.toggle("is-visible", shouldShow), root.classList.toggle("is-cart-open", cartIsOpen),
        root.toggleAttribute("inert", !shouldShow), root.setAttribute("aria-hidden", String(!shouldShow))
    }

    function updateFallbackVisibility() {
      triggerIsPast = pickerMarker.getBoundingClientRect().top < -triggerOffset(), footerIsNear = !!(
          pageFooter && pageFooter.getBoundingClientRect().top < window.innerHeight - footerHideOffset()),
        syncVisibility()
    }

    function observeOriginalControls() {
      "IntersectionObserver" in window ? (observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        triggerIsPast = !entry.isIntersecting && entry.boundingClientRect.top < 0, syncVisibility()
      }, {
        threshold: 0,
        rootMargin: `${triggerOffset()}px 0px 0px 0px`
      }), observer.observe(pickerMarker), pageFooter && (footerObserver = new IntersectionObserver(
        entries => {
          footerIsNear = entries[0].isIntersecting, syncVisibility()
        }, {
          threshold: 0,
          rootMargin: `0px 0px -${footerHideOffset()}px 0px`
        }), footerObserver.observe(pageFooter))) : (window.addEventListener("scroll",
        updateFallbackVisibility, {
          passive: !0
        }), updateFallbackVisibility())
    }
    changeButtons.forEach(button => button.addEventListener("click", changeOptions)), addButtons.forEach(
        button => button.addEventListener("click", addViaOriginalForm)), drawerOptionSlot?.addEventListener(
        "change", forwardProxyVariantChange), proxyQuantityInput?.addEventListener("change",
        forwardProxyQuantityChange), quantityInput?.addEventListener("input", syncProxyQuantity),
      quantityInput?.addEventListener("change", syncProxyQuantity), closeButtons.forEach(button => button
        .addEventListener("click", () => closeDrawer()));
    const closeFromBackdrop = event => {
      event.target === drawerBackdrop && (event.preventDefault(), closeDrawer())
    };
    drawerBackdrop?.addEventListener("pointerup", closeFromBackdrop), drawerBackdrop?.addEventListener(
      "click", closeFromBackdrop), drawer?.addEventListener("click", event => {
      (event.target === drawer || event.target === drawerBackdrop) && closeFromBackdrop(event)
    }), drawer?.addEventListener("touchmove", event => {
      event.target.closest(".sticky-atc-drawer__options") || event.preventDefault()
    }, {
      passive: !1
    }),     picker?.addEventListener("change", () => {
      window.setTimeout(() => {
        syncFromOriginalForm(), syncProxyPicker()
      }, 0)
    }), document.addEventListener("keydown", event => {
      event.key === "Escape" && !drawer?.hidden && closeDrawer()
    }), mobileQuery.addEventListener?.("change", event => {
      event.matches || closeDrawer({
          restoreFocus: !1
        }), observer?.disconnect(), footerObserver?.disconnect(), triggerIsPast = !1, footerIsNear = !1,
        observeOriginalControls()
    }), typeof subscribe == "function" && typeof PUB_SUB_EVENTS < "u" && (subscribe(PUB_SUB_EVENTS
      .productVariantChange, payload => {
        String(payload?.sectionId) === String(sectionId) && (renderVariant(payload.variant),
          syncProxyPicker())
      }), subscribe(PUB_SUB_EVENTS.headerCartOpen, syncVisibility), subscribe(PUB_SUB_EVENTS
      .headerCartClose, syncVisibility)), new MutationObserver(syncVisibility).observe(document.body, {
      attributes: !0,
      attributeFilter: ["class"]
    }), syncFromOriginalForm(), syncProxyPicker(), syncProxyQuantity(), observeOriginalControls()
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot(), document
    .addEventListener("shopify:section:load", boot)
})();